import { useEffect } from 'react'

/** @param {object} m */
export function useAbortOnUnmount(m) {
  const { chatAbortRef } = m
  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps -- ref.current read in cleanup is intentional
      chatAbortRef.current?.abort()
    }
  }, [chatAbortRef])
}
